import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const EmiDetails = () => {
  const [repaymentData, setRepaymentData] = useState(null);
  const [error, setError] = useState('');

  const location = useLocation();
  const id = new URLSearchParams(location.search).get('id');

  useEffect(() => {
    if (!id) return;
    api.get(`${base_url}/api/approveRejectLoan/getRepaymentsById`, { params: { id } })
      .then(res => setRepaymentData(res.data))
      .catch(() => setError('Error fetching EMI details'));
  }, [id]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' });
  };

  const rows = repaymentData ? [
    { label: 'EMI Number', value: repaymentData.id },
    { label: 'EMI Amount', value: repaymentData.emiAmount ? `₹${repaymentData.emiAmount}` : '—' },
    { label: 'Due Date', value: formatDate(repaymentData.dueDate) },
    { label: 'Outstanding Amount', value: repaymentData.outstandingPrincipal ? `₹${repaymentData.outstandingPrincipal}` : '—' },
    { label: 'Loan ID', value: repaymentData.loanId },
  ] : [];

  return (
    <div className="app-page">
      <TopBar title="EMI Details" backPath={`/CustomerEmiPage?id=${id}`} />

      <div className="app-content">
        {error ? (
          <div className="app-card" style={{ color: '#e53935', textAlign: 'center' }}>{error}</div>
        ) : !repaymentData ? (
          <div className="app-card" style={{ textAlign: 'center', color: '#888' }}>Loading...</div>
        ) : (
          <div className="app-card">
            <p className="section-title">EMI Information</p>
            {rows.map((row, i) => row.value ? (
              <div key={i} className="info-row">
                <span>{row.label}</span>
                <strong>{row.value}</strong>
              </div>
            ) : null)}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmiDetails;
